import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

export const BackgroundBeams = React.memo(({ className }: { className?: string }) => {
  const paths = [
    'M-366 412c-30.2 0-57.1 14.1-74.4 36.1L-160 148',
    'M-366 412c-9.1 0-17.9 1.3-26.3 3.7L-160 148',
    'M-366 412c8.9 0 17.5 1.3 25.6 3.6L-160 148',
    'M-366 412c28.5 0 54.5 13.4 71.2 34.4L-160 148',
    'M-269 295c-12.2 0-23.1 5.7-30.1 14.6L-160 148',
    'M-269 295c-3.7 0-7.3.5-10.7 1.5L-160 148',
    'M-269 295c3.6 0 7.1.5 10.4 1.5L-160 148',
    'M-269 295c11.6 0 22.1 5.4 28.9 13.9L-160 148',
  ];

  return (
    <div
      className={cn(
        'absolute h-full w-full inset-0 [mask-size:40px] [mask-repeat:no-repeat] [mask-position:center] pointer-events-none',
        className
      )}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 696 316"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-full"
      >
        <g opacity="0.3">
          {paths.map((path, index) => (
            <motion.path
              key={`path-${index}`}
              d={path}
              stroke="url(#gradient)"
              strokeWidth="0.5"
              initial={{
                pathLength: 0,
                opacity: 0,
              }}
              animate={{
                pathLength: 1,
                opacity: 1,
              }}
              transition={{
                duration: Math.random() * 3 + 2,
                ease: 'easeInOut',
                repeat: Infinity,
                repeatType: 'loop',
                repeatDelay: Math.random() * 2,
              }}
            />
          ))}
        </g>
        <defs>
          <linearGradient
            id="gradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#18CCFC" stopOpacity="0" />
            <stop offset="0.323" stopColor="#18CCFC" stopOpacity="0.8" />
            <stop offset="0.672" stopColor="#6344F5" stopOpacity="0.8" />
            <stop offset="1" stopColor="#AE48FF" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
});

BackgroundBeams.displayName = 'BackgroundBeams';